<template lang="pug">
.navigation
  v-app-bar.white.elavation-0(app light :style="$vuetify.breakpoint.smAndDown ? 'box-shadow: 0 2px 4px 0 rgba(0,0,0,.0) !important;' : 'box-shadow: 0 2px 4px 0 rgba(0,0,0,.08) !important;'")
    v-badge(overlap small :value="menu.pending_order_count" :content="menu.pending_order_count" dot color="textColorAccent")
      v-btn(icon small  @click.stop='drawer = !drawer')
        eva-icon(name="menu-outline" :fill="$vuetify.theme.themes[$theme].primary500")
    div.ml-6
      .h6.primary500--text.company-name(v-if="company") {{ $store.state.ui.currentNavbarTitle? $t($store.state.ui.currentNavbarTitle) : company.name }}
    v-spacer
    v-app-bar-nav-icon.my-auto(v-if="Auth('menu', '/admin/books-reminders')" @click.stop='showRemindersDialog = true' small)
      eva-icon(name="calendar-outline" :fill="$vuetify.theme.themes[$theme].primary500")
    v-app-bar-nav-icon.my-auto.mx-2(@click.stop='openZenDesk()' small)
      eva-icon(name="question-mark-circle-outline" :fill="$vuetify.theme.themes[$theme].primary500")
    v-badge(overlap small :value="menu.unread_count" :content="menu.unread_count" dot color="textColorAccent")
      v-btn(icon small to="/admin/notifications" @click="menu.unread_count = 0")
         eva-icon(name="bell-outline" :fill="$vuetify.theme.themes[$theme].primary500")

  v-navigation-drawer.white(app v-model='drawer' fixed :width="$vuetify.breakpoint.mdAndUp ? '270' : '250'")
    v-layout.px-4(v-if="member" @click.stop='childMenu = !childMenu' style="height:112px")
      intel-avatar.mr-3.ml-1.my-auto(v-if="drawer" :code="member.user.avatar_code" :id="member.user.id" size=40)
      v-list-item-content.ml-2.my-auto
        .h6.primary500--text(v-text="member.user.first_name")
        .c1.primary500--text(v-text="localNavbar() === 'clinic' && member.role !== 'Admin' ? $t('clinic_assistant') : member.role")
      v-list-item-icon.my-auto
        eva-icon(:name="childMenu? 'arrow-ios-upward-outline' : 'arrow-ios-downward-outline' " width="24" height="24" :fill="$vuetify.theme.themes[$theme].primary500")

    v-expand-transition.white
      v-list.pa-0(v-show="childMenu" dense :color="$vuetify.theme.themes[$theme].infoT08")
        v-list-item(@click="switchCompany" style="height:54px")
          .s1 {{ $t('switch_company') }}
        v-list-item(@click="$router.push('/signout')" style="height:54px")
          .s1.danger--text {{ $t('sign_out') }}
    v-divider.basic400(style="border:1px solid; ")

    v-list.pa-0(flat dense )
      v-list-item-group.pa-0
        template(v-for="(menuTab, i) in menuTabs")
          template(v-if="menuTab.parent")
            v-list-item.pa-0(@click="openTab(menuTab.id)" style="height:54px;" :key="'menutab'+i")
              v-layout(style="height:54px;")
                div(vertical style="width:4px;")
                v-list-item
                  v-list-item-icon.my-auto
                    //- template(v-if="menuTab.iconType === 'mdi'")
                    template(v-if="menuTab.iconType === 'eva'")
                      eva-icon(:name="menuTab.iconName" fill="var(--v-primary400)")
                    template(v-if="menuTab.iconType === 'tabler'")
                      component.ma-auto(:is="menuTab.iconName" size="24" :style="{ 'color': 'var(--v-primary400)' }")
                    template(v-if="menuTab.iconType === 'yzi'")
                      v-icon(color="primary400") {{ menuTab.iconName }}
                  v-list-item-content.ml-n3.my-auto
                    .s1.primary400--text {{ menuTab.title }}
                  v-list-item-icon.my-auto
                    eva-icon(:name="menuTab.show ? 'arrow-ios-upward-outline' : 'arrow-ios-downward-outline' " width="20" height="20" :fill="$vuetify.theme.themes[$theme].primary400")
          
            v-expand-transition
              v-list.pa-0.mx-4(v-show="menuTab.show" dense)
                template(v-for="(childMenuTab, idx) in menuTab.children")
                  router-link(:to="childMenuTab.to" v-slot="{ href, route, navigate, isActive, isExactActive }" :key="'children'+idx")
                    v-layout(style="height:40px;" @click="navigate")
                      div(vertical style="width:4px;" :style="isActive? `background-color: ${$vuetify.theme.themes[$theme].info}` : ''")
                      v-list-item(:style="isActive? `background-color: ${$vuetify.theme.themes[$theme].infoT08}` : ''")
                        v-list-item-icon.my-auto
                          //- template(v-if="childMenuTab.iconType === 'mdi'")
                          template(v-if="childMenuTab.iconType === 'eva'")
                            eva-icon(:name="childMenuTab.iconName" :fill="isActive ? `var(--v-${childMenuTab.iconColor.active})` : `var(--v-${childMenuTab.iconColor.inactive})`")
                          template(v-if="childMenuTab.iconType === 'tabler'")
                            component.ma-auto(:is="childMenuTab.iconName" size="24" :style="{ 'color': isActive ? `var(--v-${childMenuTab.iconColor.active})` : `var(--v-${childMenuTab.iconColor.inactive})` }")
                          template(v-if="childMenuTab.iconType === 'yzi'")
                            v-icon(:color="isActive ? `var(--v-${childMenuTab.iconColor.active})` : `var(--v-${childMenuTab.iconColor.inactive})`") {{ childMenuTab.iconName }}
                        v-list-item-content.ml-n3.my-auto
                          .s1(:class="isActive? 'info--text' : 'primary400--text'") {{ childMenuTab.title }}
                        v-list-item-icon.my-auto(v-if="childMenuTab.extra === 'badge'")
                          v-badge(overlap small :value="childMenuTab.extraData" :content="childMenuTab.extraData" color="textColorAccent" style="margin-top:10px")
                        v-list-item-icon.my-auto(v-if="childMenuTab.extra === 'chip'")
                          v-chip.button-AA-tiny.my-auto.px-2(x-small :value="childMenuTab.extraData" :color="$vuetify.theme.themes[$theme].primary400" outlined) {{ $t('classic') }}

            v-divider.basic300

          template(v-else-if="menuTab.functionClick")
            v-layout(style="height:54px;" @click="clickTab(menuTab.to)")
              div(vertical style="width:4px;")
              v-list-item
                v-list-item-icon.my-auto
                  template(v-if="menuTab.iconType === 'eva'")
                    eva-icon(:name="menuTab.iconName" :fill="`var(--v-${menuTab.iconColor.inactive})`")
                  template(v-if="menuTab.iconType === 'tabler'")
                    component.ma-auto(:is="menuTab.iconName" size="24" :style="{ 'color': `var(--v-${menuTab.iconColor.inactive})` }")
                  template(v-if="menuTab.iconType === 'yzi'")
                    v-icon(:color="`var(--v-${menuTab.iconColor.inactive})`") {{ menuTab.iconName }}
                v-list-item-content.ml-n3.my-auto
                  .s1(class="primary400--text") {{ menuTab.title }}
            v-divider.basic300

          template(v-else)
            router-link(:to="menuTab.to" v-slot="{ href, route, navigate, isActive, isExactActive }" :key="'menutab'+i")
              v-layout(style="height:54px;" @click="navigate")
                div(vertical style="width:4px;" :style="isActive? `background-color: ${$vuetify.theme.themes[$theme].info}` : ''")
                v-list-item(:style="isActive? `background-color: ${$vuetify.theme.themes[$theme].infoT08}` : ''")
                  v-list-item-icon.my-auto
                    //- template(v-if="menuTab.iconType === 'mdi'")
                    template(v-if="menuTab.iconType === 'eva'")
                      eva-icon(:name="menuTab.iconName" :fill="isActive ? `var(--v-${menuTab.iconColor.active})` : `var(--v-${menuTab.iconColor.inactive})`")
                    template(v-if="menuTab.iconType === 'tabler'")
                      component.ma-auto(:is="menuTab.iconName" size="24" :style="{ 'color': isActive ? `var(--v-${menuTab.iconColor.active})` : `var(--v-${menuTab.iconColor.inactive})` }")
                    template(v-if="menuTab.iconType === 'yzi'")
                      v-icon(:color="isActive ? `var(--v-${menuTab.iconColor.active})` : `var(--v-${menuTab.iconColor.inactive})`") {{ menuTab.iconName }}
                  template(v-if="menuTab.iconBadge")
                    div.d-flex.justify-start
                      v-badge.ml-n3(overlap offset-x="-3" dot :color="hasNewFeature ? 'danger500' : 'transparent'")
                        .s1(:class="isActive? 'info--text' : 'primary400--text'") {{ menuTab.title }}
                  template(v-else)
                    v-list-item-content.ml-n3.my-auto
                      .s1(:class="isActive? 'info--text' : 'primary400--text'") {{ menuTab.title }}
            v-divider.basic300

    v-divider.white.my-12
    v-divider.white.my-12

    .modals
      RemindersDialog(v-if="showRemindersDialog" :open.sync="showRemindersDialog")
      y-dialog(fill-height fluid v-model="showSupportDialog" transition="fade-transition" scrollable persistent max-width="400px")
        v-card
          v-card-title(style="height:56px;")
            .h6.basic800--text {{ $t('leave_us_message') }}
          v-divider.basic300
          v-card-text.py-3
            .s1 {{ $t('leave_us_message_question') }}
            .p2.primary400--text {{ $t('leave_us_message_desc') }}
          v-card-actions
            v-spacer
            v-btn(color='white', text @click='showSupportDialog = false')
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color='textColorAccent' dark depressed height=32 @click="sendEmail")
              .button-AA-small.basic100--text {{ $t('send_message') }}

</template>

<script>
import { mapState } from 'vuex'
import Cookies from 'js-cookie'
import IntelAvatar from '@/components/IntelAvatar.vue'

export default {
  components: { IntelAvatar },
  props: ['company', 'menu'],
  data: () => ({
    drawer: false,
    childMenu: false,
    showExtraManageMenu: false,
    showExtraSetupMenu: false,
    showExtraAppointmentMenu: false,
    showExtraYezzaBookMenu: false,
    showExtraRestaurantMenu: false,
    showExtraYezzaConnectMenu: false,
    showRemindersDialog: false,
    cwInterval: null,
    zdWidget: null,
    showSupportDialog: false,
    isOpenTab: []
  }),
  computed: {
    ...mapState('user', ['member']),
    ...mapState('ui', ['hasNewFeature']),
    ...mapState('subscriptions', ['genesData']),
    dropdownSettingsEnabled () {
      return this.menu.easyparcel_enabled || this.menu.woocommerce_enabled || this.menu.shopify_enabled || this.menu.zepto_enabled || this.menu.lalamove_enabled
    },
    menuTabs () {
      if (this.genesData && this.genesData.length > 0) {
        if (this.genesData.find(g => g.feature === 'YZ_CLINIC')) {
          return this.clinicOsNavbar()
        }
        if (this.genesData.find(g => g.feature === 'YD_FREE')) {
          return this.donationOsNavbar()
        }
        if (this.genesData.map(g => g.feature).filter(feature => feature === 'YZ_START' || feature === 'YZ_GROWTH' || feature === 'YZ_PERSONAL' || feature === 'YZ_STORE' || feature === 'YZ_LANDING_PAGE' || feature === 'YZ_BIZ' || feature === 'YZ_INTEL').length) {
          return this.yezzaNavBar()
        }
        if (this.genesData.map(g => g.feature).filter(feature => feature === 'YC_FREE' || feature === 'YC_BASIC').length) {
          return this.connectOsNavbar()
        }
        if (this.genesData.find(g => g.feature === 'YZ_REVIEW')) {
          return this.reviewOsNavbar()
        }
        return this.yezzaNavBar()
      } else if (this.localNavbar()) {
        const navbar = this.localNavbar()
        if (navbar === 'clinic') { return this.clinicOsNavbar() }
        if (navbar === 'donation') { return this.donationOsNavbar() }
        if (navbar === 'connect') { return this.connectOsNavbar() }
        if (navbar === 'review') { return this.reviewOsNavbar() }
        if (navbar === 'yezza') { return this.yezzaNavBar() }
      }
      return this.yezzaNavBar()
    }
  },
  watch: {
    drawer (val) {
      this.$store.commit('ui/setDialogVisibility', val)
    }
  },
  mounted () {
    this.drawer = window.innerWidth > 600
    window.zE(() => {
      window.zE.show()
    })
    this.cwInterval = setInterval(() => {
      const iframe = document.getElementById('launcher')
      if (iframe) {
        this.zdWidget = iframe.contentWindow.document.getElementById('Embed')
        if (this.zdWidget) {
          this.zdWidget.style.display = 'none'
          clearInterval(this.cwInterval)
        }
      }
    }, 200)
  },
  methods: {
    yezzaNavBar () {
      this.setLocalNavbar('yezza')
      let menu = []
      if (this.member && this.member.roles.includes('Agent') && this.company.id == this.$store.state.constants.AC_COMPANY_ID) {
        menu.push({ id: 'database', to: '/admin/database', iconType: 'eva', iconName: 'person-outline', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('customers'), functionClick: false, parent: false, show: false, children: [] })
        menu.push({ id: 'commission', to: '/admin/commissions', iconType: 'tabler', iconName: 'CoinIcon', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('commissions'), functionClick: false, parent: false, show: false, children: [] })
      } else {
        // Manage Tabs
        let manageChildren = []
        manageChildren.push({ to: '/admin/wallet', iconType: 'tabler', iconName: 'WalletIcon', iconColor: { active: 'info', inactive: 'primary400' }, title: this.$t('wallet'), extra: null, extraData: null })
        if (this.Auth('page', '/admin/orders')) {
          manageChildren.push({ to: '/admin/orders', iconType: 'eva', iconName: 'car-outline', iconColor: { active: 'info', inactive: 'primary400' }, title: this.$t('orders'), extra: 'chip', data: this.menu.pending_order_count })
        }
        menu.push({ id: 'manage', to: '', iconType: 'eva', iconName: 'briefcase-outline', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('manage'), functionClick: false, parent: true, show: this.isOpenTab.find(f => f === 'manage') ? true : false, children: manageChildren })

        // Connect Tabs
        if (this.Auth('page', '/admin/connect')) {
          let connectChildren = []
          connectChildren.push({ to: '/admin/connect/customers', iconType: 'eva', iconName: 'person-outline', iconColor: { active: 'info', inactive: 'primary400' }, title: this.$t('customers'), extra: null, extraData: null })
          connectChildren.push({ to: '/admin/connect/status', iconType: 'yzi', iconName: '$yzi-data-flow-01', iconColor: { active:'info', inactive: 'primary400' }, title: this.$t('status'), extra: null, extraData: null })
          connectChildren.push({ to: '/admin/connect/segments', iconType: 'eva', iconName: 'layers-outline', iconColor: { active: 'info', inactive: 'primary400' }, title: this.$t('segments'), extra: null, extraData: null })
          connectChildren.push({ to: '/admin/connect/tasks', iconType: 'eva', iconName: 'paper-plane-outline', iconColor: { active: 'info', inactive: 'primary400' }, title: this.$t('tasks'), extra: null, extraData: null })
          connectChildren.push({ to: '/admin/connect/webhook', iconType: 'eva', iconName: 'link-outline', iconColor: { active: 'info', inactive: 'primary400' }, title: this.$t('webhook'), extra: null, extraData: null })
          connectChildren.push({ to: '/admin/connect/users', iconType: 'eva', iconName: 'people-outline', iconColor: { active: 'info', inactive: 'primary400' }, title: this.$t('users'), extra: null, extraData: null })
          menu.push({ id: 'connect', to: '', iconType: 'eva', iconName: 'browser-outline', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('connect'), functionClick: false, parent: true, show: this.isOpenTab.find(f => f === 'connect') ? true : false, children: connectChildren })
        }

        // Restaurant Tabs
        if (this.Auth('page', '/admin/restaurant')) {
          let restaurantChildren = []
          restaurantChildren.push({ to: '/admin/restaurant/pos-setup', iconType: 'eva', iconName: 'layers-outline', iconColor: { active: 'info', inactive: 'primary400' }, title: this.$t('pos_setup'), extra: null, extraData: null })
          restaurantChildren.push({ to: '/admin/restaurant/menu-categories', iconType: 'eva', iconName: 'grid-outline', iconColor: { active: 'info', inactive: 'primary400' }, title: this.$t('menu_categories'), extra: null, extraData: null })
          restaurantChildren.push({ to: '/admin/restaurant/table-ordering', iconType: 'yzi', iconName: '$yzi-bell-ringing-04', iconColor: { active: 'info', inactive: 'primary400' }, title: this.$t('table_ordering'), extra: null, extraData: null })
          restaurantChildren.push({ to: '/admin/restaurant/#', iconType: 'eva', iconName: 'book-open-outline', iconColor: { active: 'info', inactive: 'primary400' }, title: this.$t('menu'), extra: null, extraData: null })
          restaurantChildren.push({ to: '/admin/restaurant/#', iconType: 'eva', iconName: 'car-outline', iconColor: { active: 'info', inactive: 'primary400' }, title: this.$t('delivery_platform'), extra: null, extraData: null })
          menu.push({ id: 'restaurant', to: '', iconType: 'yzi', iconName: '$yzi-building-02', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('restaurant'), functionClick: false, parent: true, show: this.isOpenTab.find(f => f === 'restaurant') ? true : false, children: restaurantChildren })
        }

        // Setup Tabs
        let setupChildren = []
        setupChildren.push({ to: '/admin/settings/payment', iconType: 'eva', iconName: 'credit-card-outline', iconColor: { active: 'info', inactive: 'primary400' }, title: this.$t('payment'), extra: null, extraData: null })
        if (this.Auth('page', '/admin/settings/advance-new') && (this.$currency.code === 'MYR' || this.$currency.code === 'IDR')) {
          setupChildren.push({ to: '/admin/settings/advance-new', iconType: 'eva', iconName: 'pie-chart-outline', iconColor: { active: 'info', inactive: 'primary400' }, title: this.$t('advanced_setup'), extra: null, extraData: null })
        } else if (this.Auth('page', '/admin/settings/advance') && (this.$currency.code === 'MYR' || this.$currency.code === 'IDR')) {
          setupChildren.push({ to: '/admin/settings/advance', iconType: 'eva', iconName: 'pie-chart-outline', iconColor: { active: 'info', inactive: 'primary400' }, title: this.$t('advanced_setup'), extra: null, extraData: null })
        }
        if (this.Auth('page', '/admin/settings/advance-new') && (this.$currency.code !== 'MYR' && this.$currency.code !== 'IDR')) {
          setupChildren.push({ to: '/admin/settings/advance-int', iconType: 'eva', iconName: 'pie-chart-outline', iconColor: { active: 'info', inactive: 'primary400' }, title: this.$t('advanced_setup'), extra: null, extraData: null })
        }
        menu.push({ id: 'setup', to: '', iconType: 'eva', iconName: 'shopping-bag-outline', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('setup'), functionClick: false, parent: true, show: this.isOpenTab.find(f => f === 'setup') ? true : false, children: setupChildren })
        
        // Bottom
        menu.push({ id: 'settings', to: '/admin/settings', iconType: 'eva', iconName: 'settings-outline', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('settings'), functionClick: false, parent: false, show: false, children: [] })
        menu.push({ id: 'help', to: 'openZenDesk', iconType: 'eva', iconName: 'question-mark-circle-outline', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('help_center'), functionClick: true, parent: false, show: false, children: [] })
      }
      return menu
    },
    donationOsNavbar () {
      this.setLocalNavbar('donation')
      let menu = []
      menu.push({ id: 'analytics', to: '/admin/donation/analytics', iconType: 'eva', iconName: 'bar-chart-outline', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('analytics'), functionClick: false, parent: false, show: false, children: [] })
      menu.push({ id: 'campaign', to: '/admin/donation/campaign', iconType: 'yzi', iconName: '$yzi-announcement-03', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('campaign'), functionClick: false, parent: false, show: false, children: [] })
      menu.push({ id: 'donors', to: '/admin/donation/donors', iconType: 'yzi', iconName: '$yzi-user-02', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('donors'), functionClick: false, parent: false, show: false, children: [] })
      menu.push({ id: 'segment', to: '/admin/donation/segments', iconType: 'eva', iconName: 'layers-outline', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('segments'), functionClick: false, parent: false, show: false, children: [] })
      menu.push({ id: 'settings', to: '/admin/donation/settings', iconType: 'eva', iconName: 'settings-outline', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('settings'), functionClick: false, parent: false, show: false, children: [] })
      menu.push({ id: 'help', to: 'openZenDesk', iconType: 'eva', iconName: 'question-mark-circle-outline', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('help_center'), functionClick: true, parent: false, show: false, children: [] })
      return menu
    },
    clinicOsNavbar () {
      this.setLocalNavbar('clinic')
      let menu = []
      let settingChildren = []
      settingChildren.push({ id: 'general', to: '/admin/clinic/settings', iconType: 'eva', iconName: 'settings-outline', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('general'), functionClick: false, parent: false, show: false, children: [] })
      settingChildren.push({ id: 'appointment_setup', to: '/admin/clinic/manage', iconType: 'eva', iconName: 'calendar-outline', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('appointment'), functionClick: false, parent: false, show: false, children: [] })
      if (this.Auth('page', '/admin/clinic/review-settings')) {
        settingChildren.push({ id: 'review_setting', to: '/admin/clinic/review-settings', iconType: 'yzi', iconName: '$yzi-star-01', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('review'), functionClick: false, parent: false, show: false, children: [] })
        settingChildren.push({ id: 'api_key', to: '/admin/clinic/review-api-key', iconType: 'yzi', iconName: '$yzi-key-02', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('api_key'), functionClick: false, parent: false, show: false, children: [] })
      }
      if (this.Auth('page', '/admin/clinic/user-settings')) {
        settingChildren.push({ id: 'usersettings', to: '/admin/clinic/user-settings', iconType: 'yzi', iconName: '$yzi-user-circle', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('user_settings'), functionClick: false, parent: false, show: false, children: [] })
      }
      // menu.push({ id: 'analytics', to: '/admin/clinic/analytics', iconType: 'eva', iconName: 'bar-chart-outline', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('analytics'), functionClick: false, parent: false, show: false, children: [] })
      menu.push({ id: 'appointment', to: '/admin/clinic/appointment', iconType: 'eva', iconName: 'calendar-outline', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('appointment'), functionClick: false, parent: false, show: false, children: [] })
      menu.push({ id: 'patient', to: '/admin/clinic/patients', iconType: 'yzi', iconName: '$yzi-user-02', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('patient'), functionClick: false, parent: false, show: false, children: [] })
      if (this.Auth('page', '/admin/clinic/review')) {
        menu.push({ id: 'review', to: '/admin/clinic/review', iconType: 'yzi', iconName: '$yzi-thumbs-up', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('review'), functionClick: false, parent: false, show: false, children: [] })
      }
      menu.push({ id: 'segment', to: '/admin/clinic/segments', iconType: 'eva', iconName: 'layers-outline', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('segments'), functionClick: false, parent: false, show: false, children: [] })
      menu.push({ id: 'settings', to: '/admin/clinic/settings', iconType: 'eva', iconName: 'settings-outline', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('settings'), functionClick: false, parent: true, show: this.isOpenTab.find(f => f === 'settings') ? true : false, children: settingChildren })
      menu.push({ id: 'help', to: 'openZenDesk', iconType: 'eva', iconName: 'question-mark-circle-outline', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('help_center'), functionClick: true, parent: false, show: false, children: [] })
      return menu
    },
    connectOsNavbar () {
      this.setLocalNavbar('connect')
      let menu = []
      let audienceChildren = []
      if (this.Auth('page', '/admin/connect')) {
        audienceChildren.push({ to: '/admin/connect/customers', iconType: 'eva', iconName: 'person-outline', iconColor: { active:'info', inactive: 'primary400' }, title: this.$t('customers'), extra: null, extraData: null })
        audienceChildren.push({ to: '/admin/connect/status', iconType: 'yzi', iconName: '$yzi-data-flow-01', iconColor: { active:'info', inactive: 'primary400' }, title: this.$t('status'), extra: null, extraData: null })
        menu.push({ id: 'connect', to: '', iconType: 'eva', iconName: 'people-outline', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('audience'), functionClick: false, parent: true, show: this.isOpenTab.find(f => f === 'connect') ? true : false, children: audienceChildren })

        menu.push({ to: '/admin/connect/segments', iconType: 'eva', iconName: 'layers-outline', iconColor: { active:'info', inactive: 'primary400' }, title: this.$t('segments'), extra: null, extraData: null })
        menu.push({ to: '/admin/connect/tasks', iconType: 'eva', iconName: 'paper-plane-outline', iconColor: {active: 'info', inactive: 'primary400' }, title: this.$t('tasks'), extra: null, extraData: null })
        menu.push({ to: '/admin/connect/webhook', iconType: 'eva', iconName: 'link-outline', iconColor: { active:'info', inactive: 'primary400' }, title: this.$t('webhook'), extra: null, extraData: null })
        menu.push({ to: '/admin/connect/users', iconType: 'eva', iconName: 'people-outline', iconColor: { active:'info', inactive: 'primary400' }, title: this.$t('users'), extra: null, extraData: null })
      }
      menu.push({ id: 'settings', to: '/admin/settings', iconType: 'eva', iconName: 'settings-outline', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('settings'), functionClick: false, parent: false, show: false, children: [] })
      menu.push({ id: 'help', to: 'openZenDesk', iconType: 'eva', iconName: 'question-mark-circle-outline', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('help_center'), functionClick: true, parent: false, show: false, children: [] })
      return menu
    },
    reviewOsNavbar () {
      this.setLocalNavbar('review')
      let menu = []
      let settingChildren = []
      settingChildren.push({ id: 'general_setting', to: '/admin/review/general-settings', iconType: 'eva', iconName: 'settings-outline', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('general'), functionClick: false, parent: false, show: false, children: [] })
      settingChildren.push({ id: 'review_setting', to: '/admin/review/review-settings', iconType: 'yzi', iconName: '$yzi-star-01', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('review_setup'), functionClick: false, parent: false, show: false, children: [] })
      settingChildren.push({ id: 'api_key', to: '/admin/review/api-key', iconType: 'yzi', iconName: '$yzi-key-02', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('api_key'), functionClick: false, parent: false, show: false, children: [] })
      menu.push({ id: 'review', to: '/admin/review/review', iconType: 'yzi', iconName: '$yzi-thumbs-up', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('review'), functionClick: false, parent: false, show: false, children: [] })
      menu.push({ id: 'settings', to: '/admin/review/settings', iconType: 'eva', iconName: 'settings-outline', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('settings'), functionClick: false, parent: true, show: this.isOpenTab.find(f => f === 'settings') ? true : false,  children: settingChildren })
      menu.push({ id: 'help', to: 'openZenDesk', iconType: 'eva', iconName: 'question-mark-circle-outline', iconColor: { active: 'info', inactive: 'primary400' }, iconBadge: false, title: this.$t('help_center'), functionClick: true, parent: false, show: false, children: [] })
      return menu
    },
    localNavbar () {
      const navbar = Cookies.get('yz_local_navbar')
      if (navbar) {
        return navbar
      }
      return null
    },
    setLocalNavbar (navbar) {
      if (this.$store.state.ui.currentNavbar !== navbar) {
        console.log('set', navbar)
        this.$store.commit('ui/setCurrentNavbar', navbar)
      }
    },
    openTab (id) {
      if (this.isOpenTab.find(f => f === id)) {
        this.isOpenTab = this.isOpenTab.filter(f => f !== id)
      } else {
        this.isOpenTab.push(id)
      }
    },
    clickTab (func) {
      if (func === 'openZenDesk') {
        this.openZenDesk()
      }
    },
    openZenDesk() {
      if (this.zdWidget) {
        const paths = this.$route.path.split('/')
        paths.shift()
        paths.shift()
        const searchKeywords = paths.join(" ")
        window.zE('webWidget', 'helpCenter:setSuggestions', { search: searchKeywords  })
        this.zdWidget.querySelectorAll("button")[0].click()
      }
    },
    sendEmail() {
      window.open(`mailto:support@yezza.io?subject=Question &body= %0D%0A %0D%0A %0D%0A Company: ${window.location.href} %0D%0A %0D%0A Regards, %0D%0A ${this.member.user.first_name + ' ' + this.member.user.last_name}`, '_blank')
      this.showSupportDialog = false
    },
    switchCompany () {
      if (this.$subdomain) {
        document.location.href = `https://app.${process.env.VUE_APP_BASE_DOMAIN}/companies`
      } else {
        this.$router.push('/companies')
      }
    },
    switchDesign () {
      document.location.href = `https://app.yezza.my/signin`
    }
  }
}
</script>

<style scoped>
.company-name {
  height: 1.5em;
  overflow: hidden;
}
</style>

<i18n>
{
  "en": {
    "leave_us_message_question": "How can we help you?",
    "leave_us_message_desc": "If you have any questions, please contact us at support@yezza.io. We'd be happy to help."
  },
  "id": {
    "leave_us_message_question": "Bagaimana kami bisa bantu anda?",
    "leave_us_message_desc": "Jika kamu memiliki pertanyaan, silakan hubungi kami di support@yezza.io. Kami siap membantu."
  }
}
</i18n>
